/** The Play / Stop toggle under each of Scout's answers (ChatThread).
 *
 *  Presentational only: Chat.tsx owns the one speech player
 *  (hooks/useAudioPlayer.ts) that reads answers aloud, automatically or on a
 *  tap, and says which message is speaking.  So while an answer is being read
 *  — automatically or replayed — its button is Stop, and Stop silences it
 *  completely; Play reads it again from the start. */

interface AudioPlayerProps {
  /** True while Scout's voice is reading this message. */
  playing: boolean;
  onPlay: () => void;
  onStop: () => void;
}

export default function AudioPlayer({ playing, onPlay, onStop }: AudioPlayerProps) {
  return (
    <button
      type="button"
      onClick={playing ? onStop : onPlay}
      aria-label={playing ? "Stop voice response" : "Play voice response"}
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs text-white/40 hover:text-white/70 hover:bg-white/[0.06] transition-colors"
    >
      {playing ? (
        <>
          <svg viewBox="0 0 24 24" className="w-3 h-3 fill-current" aria-hidden="true">
            <rect x="6" y="6" width="12" height="12" rx="1" />
          </svg>
          Stop
        </>
      ) : (
        <>
          <svg viewBox="0 0 24 24" className="w-3 h-3 fill-current" aria-hidden="true">
            <path d="M8 5v14l11-7z" />
          </svg>
          Play
        </>
      )}
    </button>
  );
}
